exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tekst[data-v-fd8e1454] {\ncolor: black;\n}\n.btn-block[data-v-fd8e1454] {\n  display:block;\n  float:left;\n  background-color: #008d4c ;\n}\n.btn-block[data-v-fd8e1454]:hover {\n  background-color: #008044 ;\n}\n.btn-block[data-v-fd8e1454]:focus {\n  background-color: #008044;\n  border-color: #255625;\n}\n.my-margin[data-v-fd8e1454] {\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n}\n.list-group-item[data-v-fd8e1454]:hover {\n  background-color: lightgrey;\n}\n.badge[data-v-fd8e1454] {\n  cursor: pointer;\n}\n.fa-caret-up[data-v-fd8e1454] {\n  color: white\n}\n.panel-transparent[data-v-fd8e1454] {\n  background: none;\n}\n.panel-transparent .panel-heading[data-v-fd8e1454]{\n  background: rgba(122, 130, 136, 0.1)!important;\n}\n.panel-transparent .panel-body[data-v-fd8e1454]{\n  background: rgba(46, 51, 56, 0.1)!important;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-fd8e1454","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/admin/group/EditSubgroupRules.vue
// module id = 970
// module chunks = 1